import { FC } from 'react';
import { useIntl } from 'react-intl';
import styled from 'styled-components';
import { typography } from '@clds/typography';
import { SearchEmpty } from '@clds/icon';
import { messages } from '../../../i18n';

export const NoItemsMessage: FC<React.PropsWithChildren<React.HTMLAttributes<HTMLDivElement>>> = (props) => {
  const { formatMessage } = useIntl();
  return (
    <StyledTWrapper {...props}>
      <StyledIcon data-test-specifier="search-empty-icon" size="xxl" color="secondary" />
      {formatMessage(messages.workspaceMenuEmptyList)}
    </StyledTWrapper>
  );
};

const StyledTWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100%;
  ${typography.xs.regular};
  padding: ${(props) => props.theme.spacing.md} ${(props) => props.theme.spacing.xs};
  text-align: center;
`;

const StyledIcon = styled(SearchEmpty)`
  margin-bottom: ${(props) => props.theme.spacing.sm};
`;
